import { Button as Button, Dropdown as Dropdown, ScrollSpy as ScrollSpy, Tab as Tab, Accordion as Accordion, Collapse as Collapse } from 'bootstrap';

import '@fortawesome/fontawesome-free/css/all.css';

import Swiper, { Autoplay, Navigation, Pagination, EffectFade, Mousewheel } from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination, EffectFade, Mousewheel]);
import "swiper/swiper-bundle.css";

import InfiniteScroll from "infinite-scroll";

import gsap from "gsap";
import { ScrollTrigger, TweenLite } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import AOS from "aos";
import "aos/dist/aos.css";

import './styles.scss';

document.addEventListener("DOMContentLoaded", function () {
  if ($("#header").length > 0) {
    window.addEventListener("scroll", function () {
      if (window.scrollY > 50) {
        document.getElementById("header").classList.add("scrolled");
        document.getElementById("header").classList.remove("closed");
      } else {
        document.getElementById("header").classList.remove("scrolled");
        document.getElementById("header").classList.remove("closed");
      }
    });
  }
});

window.onbeforeunload = function () {
  //window.scrollTo(0, 0);
};

$( document ).ready( function() {

  var animation = bodymovin.loadAnimation({
    container: document.getElementById("animation-container"),
    path: "../logo.json",
    renderer: "svg",
    loop: true,
    autoplay: true,
    name: "Logo Animation",
  });

  AOS.init({
    offset: 60, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 1000, // values from 0 to 3000, with step 50ms
    easing: "ease", // default easing for AOS animations
    once: true, // whether animation should happen only once - while scrolling down
  });

  $(".burger .burger-button").on("click touch", function (e) {
    e.preventDefault();
    if ($("header").hasClass("open")) {
      $("header").addClass("closed");
    } else {
      $("header").removeClass("closed");
    }
    $("header").toggleClass("open");
    
    $(".burger .burger-button").toggleClass("active");
    $(".header-right").toggleClass("active");
  });

  $(".close-button").on("click touch", function (e) {
    e.preventDefault();
    $("header").removeClass("open");
    $(".burger .burger-button").removeClass("active");
    $(".header-right").removeClass("active");
  });


  $("#menu-main-menu a[href='#']").on( 'click touch', function(e) {
    e.preventDefault();
  })


  if(window.location.hash) {
    var target = window.location.hash;
    $("html, body").animate({ scrollTop: $(target).offset().top - 85 }, 0);
  }

  $(function () {
    $('.current-menu-item a[href*="#"]:not([href="#"])').click(function () {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        //var target = $(this.hash);
        var target = $( this ).attr( 'href' );
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {

          target = "#" + target.split('#').pop();

          console.log( target );

          $("header").removeClass("open");
          $('.burger-button').removeClass("active");
          $(".header-right").removeClass("active");

          $("html, body").animate(
            { scrollTop: $(target).offset().top - 0 },
            0
          );
          return false;
        }
      }
    });
  });

  $('.anchor').on('click touch', function (e) {
    e.preventDefault();
    var target = $(this).attr( 'href' );
    if ($(target).length > 0) {
      $("html, body").animate({ scrollTop: $(target).offset().top - 85 }, 0);
      return false;
    } else {
      $("html, body").animate({ scrollTop: $("#footer").offset().top - 85 }, 0);
      return false;
    }
  });


  var sectorsSwiper = new Swiper(".sectors_block .vertical-slider .swiper", {
    loop: true,
    autoHeight: true,
    height: 250,
    autoplay: {
      delay: 700,
      disableOnInteraction: true
    },
    direction: "vertical",
    speed: 1000,
    slidesPerView: 5,
    spaceBetween: 0,
    centeredSlides: true,
    breakpoints: {
      1200: {
        height: 300
      },
      1500: {
        height: 350
      },
      1700: {
        height: 450
      }
    }
  });


  var sectorsGridSwiper = new Swiper(".sectors_block .grid-row .swiper", {
    loop: true,
    loopedSlides: 4,
    autoHeight: false,
    watchSlidesProgress: true,
    autoplay: {
      delay: 5000,
    },
    speed: 1300,
    slidesPerView: 1.2,
    spaceBetween: 42,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 3,
      },
      1500: {
        slidesPerView: 4
      },
    },
  });


  $("header li.menu-item-has-children > a").on("click touch", function (e) {
    if ($(window).width() < 992) {
      e.preventDefault();
      $(this).parent("li").toggleClass("active");
      $(this).parent("li").find(".sub-menu").first().slideToggle("linear");
    }
  });


  if( $(".articles-list-container").length > 0 ) {
    var total = $("#post-list .article-container").length;
    $(".load-total .shown").text(total);

    let elem = document.querySelector(".articles-list-container");

    let infScroll = new InfiniteScroll(elem, {
      // options
      path: ".pagination a",
      append: ".article-container",
      history: false,
      loadOnScroll: false,
    });

    var $viewMoreButton = $(".pagination a");

    $viewMoreButton.on("click", function (e) {
      e.preventDefault();
      infScroll.loadNextPage();
    });

    infScroll.on("last", function (event, response, path) {
      $(".pagination").hide();
    });
  }


  gsap.utils.toArray(".section").forEach((section, i) => {
    if (section.getAttribute("data-colour") !== null) {
      var colourAttr = section.getAttribute("data-colour");

      gsap.to(".main-body", {
        backgroundColor: colourAttr === "black" ? "#000" : "#fff",
        color: colourAttr === "black" ? "#fff" : "#000",
        immediateRender: false,
        scrollTrigger: {
          trigger: section,
          scrub: true,
          start: "300 bottom",
          end: "600 bottom",
          //markers: { startColor: "green", endColor: "red", fontSize: "12px" },
        },
      });
    }
  });


  gsap.utils.toArray("footer .line.vertical-line").forEach((verticalLine, i) => {
    gsap.to(verticalLine, {
      height: "500px",
      immediateRender: false,
      scrollTrigger: {
        trigger: verticalLine,
        scrub: true,
        start: "150 bottom",
        end: "500 bottom",
      },
    });
  });

  gsap.utils.toArray(".line.horizontal-line").forEach((horizontalLine, i) => {
    if( $( window ).width > 991 ) {
      gsap.to(horizontalLine, {
        width: "100vw",
        immediateRender: false,
        scrollTrigger: {
          trigger: horizontalLine,
          scrub: true,
          start: "top 90%",
          end: "+=150%",
        },
      });
    } else {
      gsap.to(horizontalLine, {
        width: "100vw",
        immediateRender: false,
        scrollTrigger: {
          trigger: horizontalLine,
          scrub: true,
          start: "top 90%",
          end: "+=65%",
        },
      });
    }
  });

  gsap.utils.toArray(".line.horizontal-line-bottom").forEach((horizontalLineBottom, i) => {
    if ($(window).width > 991) {
      gsap.to(horizontalLineBottom, {
        width: "100vw",
        immediateRender: false,
        scrollTrigger: {
          trigger: horizontalLineBottom,
          scrub: true,
          start: "bottom 90%",
          end: "+=150%",
        },
      });
    } else {
      gsap.to(horizontalLineBottom, {
        width: "100vw",
        immediateRender: false,
        scrollTrigger: {
          trigger: horizontalLineBottom,
          scrub: true,
          start: "bottom 90%",
          end: "+=65%",
        },
      });
    }
  });

  gsap.utils.toArray(".line.horizontal-line-fast").forEach((horizontalLine, i) => {
    gsap.to(horizontalLine, {
      width: "100vw",
      immediateRender: false,
      scrollTrigger: {
        trigger: horizontalLine,
        scrub: true,
        start: "top 90%",
        end: "+=50%",
      },
    });
  });


  var circle = $(".mouse-cursor");

  function moveCircle(e) {
    gsap.to(circle, 0.3, {
      css: {
        left: e.pageX,
        top: e.pageY,
      },
    });
  }

  $(window).on("mousemove", moveCircle);

  $('body' ).on( 'mouseenter', '.button', function() {
    if( $( this ).hasClass( 'accent-pink' ) ) {
      $(".mouse-cursor").addClass("accent-pink").removeClass("accent-blue");
    }  else {
      $(".mouse-cursor").addClass("accent-blue").removeClass("accent-pink");
    }
    $(".mouse-cursor").addClass("mouse-cursor-button");
  }).on( 'mouseleave', '.button', function() {
    $(".mouse-cursor").removeClass("mouse-cursor-button");
  })

  $("body")
    .on("mouseenter", ".file_upload-container", function () {
      $(".mouse-cursor").addClass("accent-blue").removeClass("accent-pink");
      $(".mouse-cursor").addClass("mouse-cursor-button");
    })
    .on("mouseleave", ".file_upload-container", function () {
      $(".mouse-cursor").removeClass("mouse-cursor-button");
    });

  $('body' ).on( 'mouseenter', '.nf-mp-footer li', function() {
    $(".mouse-cursor").addClass("accent-pink").removeClass("accent-blue");
    $(".mouse-cursor").addClass("mouse-cursor-button");
  }).on( 'mouseleave', '.nf-mp-footer li', function() {
    $(".mouse-cursor").removeClass("mouse-cursor-button");
  })


  $('body' ).on( 'mouseenter', '.swiper-container .swiper', function() {
    $(".mouse-cursor").addClass("mouse-cursor-swiper");
  }).on( 'mouseleave', '.swiper', function() {
    $(".mouse-cursor").removeClass("mouse-cursor-swiper");
  })

    $('body' ).on( 'mouseenter', '.vertical-slider .swiper', function() {
    $(".mouse-cursor").addClass("mouse-cursor-swiper-vert");
  }).on( 'mouseleave', '.swiper', function() {
    $(".mouse-cursor").removeClass("mouse-cursor-swiper-vert");
  })

  $('body' ).on( 'mouseenter', '.popup-video', function() {
    $(".mouse-cursor").addClass("mouse-cursor-video");
  }).on( 'mouseleave', '.popup-video', function() {
    $(".mouse-cursor").removeClass("mouse-cursor-video");
  })


  $('body' ).on( 'mouseenter', '.sectors_block .sector', function() {
    $(this).find(".hover-content").slideDown(500);
  }).on( 'mouseleave', '.sectors_block .sector', function() {
    $(this).find(".hover-content").slideUp(500);
  });



  $(".popup-video").magnificPopup({
    type: "iframe",
    mainClass: "mfp-fade",
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
  });

  $("a[href='#contact']").on("click touch", function (e) {
    e.preventDefault();
    $("header").removeClass("open");
    $(".burger .burger-button").removeClass("active");
    $(".header-right").removeClass("active");
    $("#contact-slideout").toggleClass("active");
  });

  $(".contact-slideout-close").on("click touch", function (e) {
    e.preventDefault();
    $("#contact-slideout").removeClass("active");
  });


});